import React from "react";
import Select from "react-select";
import Overlay from "../../../components/overlay";

export default function() {
  const { forms = [], loading, selectedMachine } = this.state;
  return (
    <div>
      <label>Machine Number</label>
      <Select value={selectedMachine} />
      {loading && <Overlay />}
      {forms.length === 0 && (
        <div className="placeholder">
          {navigator.onLine ? "No previous reports" : "Cant retreive reports"}
        </div>
      )}
      {forms.map((form, key) => this._renderForm(form, key))}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/machines/machine-history/view.js